import { Suspense } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { cn } from '@shared/lib/cn'
import { Tabs, TabsVariant } from '@shared/ui'
import { Spinner } from '@shared/ui/Spinner'
import type { TabItem } from '@shared/ui/Tabs/Tabs'

interface InnerNavigationLayoutProps {
  items: TabItem[]
  showTitle?: boolean
  className?: string
}

export function InnerNavigationLayout({ items, showTitle, className }: InnerNavigationLayoutProps) {
  const location = useLocation()
  const navigate = useNavigate()

  const activeTab = items.find((i) => i.value === location.pathname)?.value ?? items[0]?.value

  return (
    <div className={cn('space-y-6', className)}>
      {showTitle && (
        <h1 className="text-xl font-semibold">{items.find((i) => i.value === activeTab)?.label}</h1>
      )}

      <Tabs
        variant={TabsVariant.underline}
        items={items}
        value={activeTab}
        onValueChange={(v) => navigate(v)}
      />

      <Suspense
        fallback={
          <div className="flex h-full items-center justify-center">
            <Spinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  )
}
